<template>
  <div class="fccGestaoArquivos">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage titlePage="Arquivos" />
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :status="status"
            :actions="actions"
            addFilter
            :items="listarGestaoArquivo"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            fieldVisibility
            pdf
            csv
            xls
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          >
          </fccTable>
        </div>
      </div>
    </div>
    <fccModal
      centered
      idModal="addFieldModal"
      titleModal="Novo Arquivo"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="criarGestaoArquivo" autocomplete="off">
        <div class="my-2">
          <div class="row">
            <div class="col-sm-6">
              <label>Selecione o repositório</label>
              <v-select
                :options="listagemRepo"
                v-model="repositorio"
                :placeholder="name"
                class="selectSPI"
                label="repodescricao"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!repositorio"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criar.arqcadcodigo"
                >Código</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criar.arqcaddescricao"
                >Descrição</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criar.arqcadbanco"
                >Banco</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criar.arqcadtabela"
                >Tabela</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criar.arqcadcampo"
                >Campo</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <label>Ativo</label><br />
              <toggle-button v-model="criar.arqcadativo" />
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton tipo="submit">{{ labelsSystem.salvar }}</fccButton>
            </div>
          </div>
        </div>
      </form>
    </fccModal>
    <fccModal
      centered
      idModal="editFieldModal"
      titleModal="Editar Arquivo"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="editarGestaoArquivo" autocomplete="off">
        <div class="my-2">
          <div class="row my-2">
            <div class="col-sm-6">
              <label>Selecione o repositório</label>
              <v-select
                :options="listagemRepo"
                v-model="repositorio"
                :placeholder="name"
                class="selectSPI"
                label="repodescricao"
                :reduce="(repoDescricao) => repoDescricao.repoid"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!repositorio"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="editar.arqcadcodigo"
                >Código</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="editar.arqcaddescricao"
                >Descrição</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="editar.arqcadbanco"
                >Banco</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="editar.arqcadtabela"
                >Tabela</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="editar.arqcadcampo"
                >Campo</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <label>Ativo</label><br />
              <toggle-button v-model="editar.arqcadativo" />
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Gestão Arquivos',
      titlePDF: 'Lista de Gestão Arquivos',
      itemPorPage: '100',
      baseUrlSga: store.state.baseUrlSga,
      listagemGestaoArquivo: [],
      repositorioSelected: '',
      listagemRepo: [],
      name: 'Repositório',
      repositorio: '',
      editar: {
        repoid: '',
        arqcadid: '',
        arqcadcodigo: '',
        arqcaddescricao: '',
        arqcadativo: false
      },
      fields: [
        { key: 'repodescricao', label: 'Repositório', sortable: true, active: true },
        { key: 'arqcadcodigo', label: 'Código', sortable: true, active: true },
        { key: 'arqcaddescricao', label: 'Descrição', sortable: true, active: true },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          tdClass: 'no-print',
          thClass: 'no-print',
          active: true
        },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      criar: {
        repoid: '',
        arqcadid: '',
        arqcadcodigo: '',
        arqcaddescricao: '',
        arqcadativo: false
      },
      status: [
        {
          funcaoButton: 'changeStatus',
          tooltip: 'Alterar Status',
          campoStatus: 'arqcadativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  methods: {
    changeStatus: function (action, item) {
      this.repositorio = item.repoid
      this.editar = item
      this.editarGestaoArquivo()
    },
    listandoGestaoArquivos: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSga + '/ArquivoCadastro/ListaTodosArquivoCadastro',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemGestaoArquivo = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listandoRepo: function () {
      axios
        .get(
          this.baseUrlSga + '/Repositorio/ListaTodosRepositorio',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemRepo = response.data
        })
        .catch(this.setErrorSystem)
    },
    addField: function () {
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    editField: function (action, item) {
      this.editar = item
      this.repositorio = this.editar.repoid
      this.$root.$emit('bv::show::modal', 'editFieldModal')
    },
    deleteField: function (action, item) {
      this.callConfirm(this.mensagemExcluir, item.arqcaddescricao).then(() => {
        axios
          .delete(
            this.baseUrlSga + '/ArquivoCadastro/ExcluirArquivoCadastro?idArqCad=' + item.arqcadid,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listandoGestaoArquivos()
            this.callToast(this.mensagensUpdate.editado)
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      })
    },
    criarGestaoArquivo: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      this.criar.repoid = this.repositorio.repoid
      this.criar.arqcadid = 0
      axios
        .post(
          this.baseUrlSga + '/ArquivoCadastro/InserirArquivoCadastro',
          this.criar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoGestaoArquivos()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    editarGestaoArquivo: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      this.editar.repoid = this.repositorio
      axios
        .put(
          this.baseUrlSga + '/ArquivoCadastro/AlterarArquivoCadastro',
          this.editar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoGestaoArquivos()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'editFieldModal')
          this.callToast(this.mensagensUpdate.editado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'editFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted: function () {
    this.listandoGestaoArquivos()
    this.listandoRepo()
  },
  computed: {
    listarGestaoArquivo() {
      return this.listagemGestaoArquivo
    }
  }
}
</script>
